module.exports = __webpack_public_path__ + "static/media/logo.4d7b9b63.png";